// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"310724fc","787":"e07cc327"}[chunkId] + ".chunk.js";
};